/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
const INITIAL_CONTEXT = {
    idle: {},
};

const MACHINE_CONFIG = {
    id: "io.vlinder.klefki-admin.roles",
    initial: "idle",
    context: INITIAL_CONTEXT,
    states: {
        idle: {
            entry: ["resetAction"],
            on: {
                START: { target: "GET_ROLES" },
            },
        },
        GET_ROLES: {
            invoke: {
                id: "getRoles",
                src: "getRoles",
                onDone: {
                    target: "RENDER_ROLES",
                    actions: ["successAction"],
                },
                onError: {
                    target: "RENDER_ROLES_ERROR",
                    actions: ["failureAction"],
                },
            },
        },
        RENDER_ROLES: {
            on: {
                START: { target: "GET_ROLES" },
            },
        },
        RENDER_ROLES_ERROR: {
            on: {
                START: { target: "GET_ROLES" },
            },
        },
    },
};

//Machine(MACHINE_CONFIG)

export { INITIAL_CONTEXT, MACHINE_CONFIG };
